
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.487 7.323l-4.28-4.28-1.414 1.414L15.5 6.164v4l2.5 2.5V17a1 1 0 01-2 0v-3c0-1.654-1.346-3-3-3h-1V6a2 2 0 00-2-2H6a2 2 0 00-2 2v14h8v-7h1a1 1 0 011 1v3c0 1.654 1.346 3 3 3s3-1.346 3-3V8.561c0-.468-.182-.908-.513-1.238zM10 10H6V7h4v3zm7.5-.664V8.164l.5.5v1.172l-.5-.5z","fill":"currentColor"}})])
          )
        }
      }
    